import { render, staticRenderFns } from "./FileCheckButton.vue?vue&type=template&id=4ddd9f65"
import script from "./FileCheckButton.vue?vue&type=script&lang=ts"
export * from "./FileCheckButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports